import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { Content } from 'styles/globalStyles';
import { setGlobalErrorMsg } from 'store/global/globalActions';
import PackageService from 'services/package';
import useTitle from 'hooks/useTitle';
import EventLogsTable from './EventLogsTable';

const ListPackageEvents = ({ currentPackage }) => {
  useTitle('Git Events History');
  const dispatch = useDispatch();
  const [commits, setCommits] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchGitEvents = async () => {
    setLoading(true);
    try {
      const res = await PackageService.fetchGitEvents({
        package_slug: currentPackage.slug,
      });
      setCommits(res);
    } catch (err) {
      dispatch(setGlobalErrorMsg(err));
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchGitEvents();
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <Content className='main-users-table'>
        <EventLogsTable loading={loading} commits={commits} />
      </Content>
    </Fragment>
  );
};

export default ListPackageEvents;
